import React from 'react';

import Segmented, { SegmentedOption } from 'components/DesignSystem/Segmented';
import useObservedDataControlPanel from 'utils/hooks/meteorology/useObservedDataControlPanel';
import { ObservedDataPeriodMode } from 'types/Meteorology/Fields/ObservedData/getOptions';

import './index.scss';

const MODE_OPTIONS: { id: ObservedDataPeriodMode; label: string }[] = [
  { id: 'preset', label: 'Pré-definido' },
  { id: 'date', label: 'Data' },
  { id: 'free', label: 'Livre' },
];

export default function PeriodSection() {
  const {
    isHeatmap, mode, setMode, availableTabs, getSelector,
  } = useObservedDataControlPanel();

  const options: SegmentedOption<ObservedDataPeriodMode>[] = MODE_OPTIONS
    .filter((option) => availableTabs.includes(option.id))
    .map((option) => ({ value: option.id, label: option.label }));

  return (
    <div className="observed-data-period-section">
      {!isHeatmap && options.length > 0 && (
        <Segmented
          className="observed-data-period-mode-switch"
          options={options}
          value={mode}
          onChange={setMode}
        />
      )}
      {getSelector()}
    </div>
  );
}
